import React from "react";
import { useLang } from "../../context/LanguageContext";
import { IMAGES } from "../../lib/constants";
import { Reveal } from "./Reveal";

export const About = () => {
  const { t } = useLang();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-40 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          {/* Text */}
          <div className="lg:col-span-6 lg:pt-16">
            <Reveal>
              <span className="text-xs uppercase tracking-[0.35em] text-amber-800/80">
                — {t.about.overline}
              </span>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-stone-900">
                {t.about.title}
              </h2>
            </Reveal>
            <Reveal delay={160}>
              <div className="mt-10 space-y-6 max-w-xl text-stone-600 text-lg leading-relaxed font-light">
                <p>{t.about.p1}</p>
                <p>{t.about.p2}</p>
                <p>{t.about.p3}</p>
              </div>
            </Reveal>

            {/* Stats */}
            <Reveal delay={220}>
              <div className="mt-12 grid grid-cols-3 gap-6 border-t border-stone-200 pt-10">
                {[t.about.stat1, t.about.stat2, t.about.stat3].map((s, i) => (
                  <div key={i} data-testid={`about-stat-${i}`}>
                    <div className="font-heading text-4xl md:text-5xl text-stone-900">
                      {s.n}
                    </div>
                    <div className="mt-2 text-[11px] uppercase tracking-[0.2em] text-stone-500">
                      {s.l}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          {/* Images aligned grid */}
          <div className="lg:col-span-6 relative">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              <Reveal delay={140}>
                <div className="image-hover aspect-[4/5] bg-stone-100">
                  <img
                    src={IMAGES.about}
                    alt="Annette Rooms"
                    className="w-full h-full object-cover"
                  />
                </div>
              </Reveal>
              <Reveal delay={220} className="hidden md:block">
                <div className="image-hover aspect-[4/5] bg-stone-100">
                  <img
                    src={IMAGES.sea1}
                    alt="Sea view"
                    className="w-full h-full object-cover"
                  />
                </div>
              </Reveal>
              <Reveal delay={300} className="md:col-span-2">
                <div className="bg-stone-900 text-white p-6 md:p-8 flex gap-6 items-start">
                  <div className="font-heading text-4xl md:text-5xl italic text-amber-100 leading-none shrink-0">
                    "
                  </div>
                  <div>
                    <p className="text-sm md:text-base font-light leading-relaxed">
                      {t.reviews.items[0].text.slice(0, 160)}…
                    </p>
                    <div className="mt-4 text-[11px] uppercase tracking-[0.2em] text-stone-400">
                      {t.reviews.items[0].author} · {t.reviews.items[0].country}
                    </div>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
